"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatAddressFieldTitleCase;
var _formatTitleCase = require("./formatTitleCase");
var addressExceptions = ['and', 'by', 'cum', 'de-la', 'en-le', 'in', 'next', 'of', 'on', 'super', 'the', 'under', 'upon', 'with'];
function formatAddressFieldTitleCase(input) {
  return (0, _formatTitleCase.formatTitleCaseWithExclusions)(input, ['-', ' '], addressExceptions);
}